/**
 * @desc 教务
 */

const education = r =>
  require.ensure([], () => r(require('../views/education/Education.vue')), 'education')

const schedule = r =>
  require.ensure([], () => r(require('../views/education/Schedule.vue')), 'schedule')

const classList = r =>
  require.ensure([], () => r(require('../views/education/ClassList.vue')), 'classList')

//教室
const classroom = r =>
  require.ensure([], () => r(require('../views/education/Classroom.vue')), 'classroom')

//教务设置
const educationSet = r =>
  require.ensure([], () => r(require('../views/education/EducationSet.vue')), 'educationSet')

//教务设置
const classDetail = r =>
  require.ensure([], () => r(require('../views/education/ClassDetail.vue')), 'classDetail')

const lessonPlan = r =>
  require.ensure([], () => r(require('../views/education/LessonPlan.vue')), 'lessonPlan')

const overview = r =>
  require.ensure([], () => r(require('../views/education/Overview.vue')), 'overview')

const classBatch = r =>
  require.ensure([], () => r(require('../views/education/classBatch.vue')), 'classBatch')

export default [
  {
    name: 'education',
    path: '/education',
    component: education,
    meta: { title: '教务' },
    children: [
      //课表
      {
        name: 'schedule',
        path: '/schedule',
        component: schedule,
        meta: { title: '课表' },
      },
      //班级
      {
        name: 'classList',
        path: '/classList',
        component: classList,
        meta: { title: '班级' },
      },
      {
        name: 'classDetail',
        path: '/classDetail',
        component: classDetail,
        meta: { title: '班级详情' },
      },
      {
        name: 'classList/classBatch',
        path: 'classBatch',
        component: classBatch,
        meta: { title: '批量建班' },
      },
      //教室
      {
        name: 'classroom',
        path: '/classroom',
        component: classroom,
        meta: { title: '教室' },
      },
      //教务设置
      {
        name: 'educationSet',
        path: '/educationSet',
        component: educationSet,
        meta: { title: '教务设置' },
      },
      {
        name: 'lessonPlan',
        path: '/lessonPlan',
        component: lessonPlan,
        meta: { title: '放假计划' },
      },
      {
        name: 'overview',
        path: '/overview',
        component: overview,
        meta: { title: '总览' },
      },
    ],
  },
]
